import type { FC, ReactElement } from 'react';
import type { OfferAndFilters } from '../../interfaces';
import { ResultItemDetails } from './ResultItemDetails';
import { ResultItemImages } from './ResultItemImages';

export const ResultListItem: FC<OfferAndFilters> = ({ offer, filters }): ReactElement<OfferAndFilters> => (
    <article className="grid ads__unit skeleton-screen u-pa2" data-testid={`resultListItem-${offer.offerId}`}>
        <ResultItemImages offer={offer} filters={filters} />
        <ResultItemDetails offer={offer} filters={filters} />
    </article>
);
